import { gql } from '@apollo/client';

export const SEND_EMAILS = gql`
  mutation sendEmails($inputs: [EmailEventInput!]!) {
    sendEmailEvents(inputs: $inputs) {
      totalSent
      totalFailed
      failures {
        name
        data
        message
      }
    }
  }
`;
